module.exports = __webpack_public_path__ + "static/media/noimage.18bacdc5.jpg";